export default __webpack_public_path__ + "static/404-6d319f63bcf548f8d8b38b5616c55465.gif";